// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"_2diRw","logo":"_25Zr6"};